import { render, staticRenderFns } from "./ModalAddIntervention.vue?vue&type=template&id=4f956350&scoped=true"
import script from "./ModalAddIntervention.vue?vue&type=script&lang=js"
export * from "./ModalAddIntervention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f956350",
  null
  
)

export default component.exports